import styled from 'styled-components';

const CountryCodeInputStyled = styled.div`
  font-family: 'Mulish';

  .label-mobile-number {
    color: ${(props) => props.theme.text.medium};
    font-size: 13px;
    margin-top: 16px;
  }

  .country-div {
    display: flex;
  }

  .form-floating > .form-control-plaintext ~ label,
  .form-floating > .form-control:focus ~ label,
  .form-floating > .form-control:not(:placeholder-shown) ~ label {
    color: ${(props) => props.theme.text.light};
    -webkit-transform: scale(1) translateY(-24px) translateX(-112px);
    -moz-transform: scale(1) translateY(-24px) translateX(-112px);
    transform: scale(1) translateY(-24px) translateX(-112px);
    font-size: 13px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
  }

  .form-floating > .form-control,
  .form-floating > .form-control-plaintext,
  .form-floating > .form-select {
    height: 43px !important;
    min-height: 43px !important;
    min-height: 43px !important;
  }

  .form-floating > label {
    color: ${(props) => (props?.darkMode ? props.theme.color.white : props.theme.text.light)};
    opacity: ${(props) => (props?.darkMode ? '50%' : '100%')};
    font-size: 16px;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;
    margin-top: -2px;
  }

  .btn.dropdown-toggle {
    border: 0px;
    margin: 0 38px 0 0;
  }

  .input-group {
    border: none;
    border-bottom: 1px solid ${(props) => props.theme.color.border};
    padding-bottom: 10px;
  }

  .input-group:hover {
    border: none;
    border-bottom: 1px solid ${(props) => props.theme.blue.dark};
  }

  .invalid-error {
    line-height: 20px;
    height: 20px;
    margin-top: 8px;
    font-weight: 600;
    font-size: 16px;
  }

  .country-dropdown-toggle {
    padding: 0px;
    background-color: transparent !important;
    color: ${(props) => (props?.darkMode  ? props.theme.color.white : props.theme.color.black)};
    padding-left: 0px;
  }

  .country-dropdown-toggle::after {
    display: none;
  }

  .country-dropdown-toggle:hover {
    background-color: transparent !important;
    color: ${(props) => (props?.darkMode  ? props.theme.color.white : props.theme.color.black)};
  }

  .country-dropdown-arrow {
    margin-left: 8px;
    padding-right: 8px;
  }

  .dropdown-border {
    border-right: 1px solid ${(props) => props.theme.color.border};
    width: 100px;
  }

  .country-dropdown-code {
    margin-left: 8px;
    font-weight: 700;
    font-size: 16px;
  }

  .country-dropdown-textbox {
    border: 0px;
    font-weight: 600;
    font-size: 18px;
    margin-top: -16px;
  }

  .country-scrollbar {
    max-height: 360px;
    width: 500px;
    overflow-y: auto;
  }

  .country-scrollbar::-webkit-scrollbar {
    width: 6px;
  }

  .country-scrollbar::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.color.border};
    border-radius: 4px;
  }

  .country-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: ${(props) => props.theme.color.borderLight};
  }

  .country-scrollbar::-webkit-scrollbar-track {
    background-color: ${(props) => props.theme.color.borderLight};
  }

  .country-dropdown-item {
    border-bottom: 1px solid ${(props) => props.theme.color.borderLight};
    padding-top: 16px;
    padding-bottom: 16px;
    margin-left: 12px;
    margin-right: 12px;
  }

  .country-name {
    font-size: 15px;
    font-weight: 600;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: left;
  }

  .country-code {
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: ${(props) => props.theme.text.medium};
  }

  .country-name,
  .country-code {
    text-align: left;
  }

  &.rtl { 
    .country-scrollbar {
      direction: rtl;
    }
    .country-dropdown-item {
      text-align: right;
    }
  }
`;

export default CountryCodeInputStyled;
